module.exports = __webpack_public_path__ + "img/f04b56a.svg";